import React, { useEffect } from 'react';
import Navbar from '../../components/layout/Navbar';
import Footer from '../../components/layout/Footer';
import ScienceBackground from '../../components/layout/ScienceBackground';
import AboutSection from '../../components/layout/AboutSection';

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="font-sans bg-slate-50 min-h-screen text-slate-800 overflow-x-hidden selection:bg-rose-500 selection:text-white relative flex flex-col">
      <ScienceBackground />
      <Navbar />
      
      {/* Page Header */}
      <div className="relative flex-grow pt-32 pb-16 md:pt-40 md:pb-20 px-4 text-center z-10">
        <div className="absolute inset-x-0 top-0 h-64 bg-gradient-to-b from-orange-50 to-transparent -z-10"></div>
        <h1 className="text-4xl md:text-5xl lg:text-7xl font-black uppercase tracking-tight text-slate-800 mb-4 drop-shadow-sm">
          About <span className="text-orange-500">Us</span>
        </h1>
        <p className="text-lg text-slate-500 font-medium max-w-2xl mx-auto mb-16">
          Discover our vision, dedication, and the driving force behind Kasun Walakumbura Science Education Center.
        </p>

        <div className="relative z-10 pb-20">
          <AboutSection />
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AboutUs;
